export default {
  inbox: {
    title: 'Inbox',
    pending: 'Pending',
    treated: 'Treated'
  },
  outbox: {
    title: 'Outbox',
    pending: 'Pending to be sent',
    sent: 'Sent',
    accepted: 'Accepted',
    rejected: 'Rejected'
  },
  start: 'Start',
  search: 'Search',
  stored: 'Stored Invoices',
  rioja: {
    queryProcedure: 'Expected payment date',
    queryThirdparty: 'Third parties file'
  }
}
